import $ from 'jquery';

function utmBasedContent() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const utmContent = urlParams.get('utm_content');
  if( utmContent === null ) {
    return;
  }

  /*
  $(`[data-utm-based-element]`).each(function(){
    const $element = $(this);
    const key = $element.attr(`data-utm-based-element`);
    if( $element.filter(`[data-utm-content="${utmContent}"]`).length ) {
      $(`[data-utm-based-element="${key}"]`).hide();
      $(`[data-utm-based-element="${key}"]`).filter(`[data-utm-content="${utmContent}"]`).show();
    }
  });
  */

  let utmKeys = [];
  $(`[data-utm-based-element]`).each(function(){
    const $element = $(this);
    const key = $element.attr(`data-utm-based-element`);
    if( !utmKeys.includes(key) ) {
      utmKeys.push(key);
    }
  });

  for( let i=0 ; i<utmKeys.length ; i++ ) {
    const key = utmKeys[i];
    let hasDynamicElement = false;

    $(`[data-utm-based-element="${key}"]`).each(function(){
      const $element = $(this);
      const elementUtmArray = $element.attr(`data-utm-content`).split(', ');

      if( elementUtmArray.includes(utmContent) || elementUtmArray.includes(`*`) ) {
        $element.attr('data-utm-based-visible', 'true');
        hasDynamicElement = true;
      }
    });

    if( hasDynamicElement ) {
      $(`[data-utm-based-element="${key}"]`).hide().filter(`[data-utm-based-visible]`).show();
    }
  }
}

export default utmBasedContent;
